class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if(event.target.type !== 'range'){
        this.onSubmitHandler(event);
      }
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const filterElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);

      if (!filterElement) return;

      const isDisabled = element.classList.contains('is-disabled');

      if (!isDisabled) {
        filterElement.classList.remove('is-disabled');
        filterElement.innerHTML = element.innerHTML;
      } else {
        filterElement.classList.add('is-disabled');
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a')?.addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class DetailsHolder extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector('.js-facets-desktop');
    this.mainDetailsToggle = this.querySelector('details');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.container.querySelectorAll('.facets__summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
  }

  handleBodyClick(event) {
    const target = event.target;
    const isNotDetails = target !== this.mainDetailsToggle;
    const isNotDetailsElement =  !target.closest('details-holder');

    if (isNotDetails && isNotDetailsElement) {
      const holder = target.closest('details-holder');
      this.activeElement = holder ? holder.querySelector('summary') : null;
      this.close();
    }
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      this.container.querySelectorAll('details').forEach(details => {
        if (details !== detailsElement) {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', false);
        }
      });

      document.body.addEventListener('click', this.onBodyClick);
    });
  }

  close() {
    this.container.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', false);
    });

    document.body.removeEventListener('click', this.onBodyClick);
  }
}

customElements.define('details-holder', DetailsHolder);


class RangeSlider extends HTMLElement {
  
  rangeOneInitialValue;
  rangeTwoInitialValue;
  sliderOne = this.querySelector("#slider-1");
  sliderTwo = this.querySelector("#slider-2");  
  displayValOne = this.querySelector("#range1");
  displayValTwo = this.querySelector("#range2");
  sliderTrack = this.querySelector(".slider-track");
  minGap = 0;
  sliderMaxValue;
  sliderMinValue;
  inputs;
  sliderName;
  rangeFacet;
  rangeFacetMobile;
  unit;

  formatValue(val) {
    return this.unit ? `${val} ${this.unit}` : `${val}`;
  }

  constructor() {
    super();
    this.unit = this.dataset.unit || '';
    this.inputs = this.querySelectorAll('.facet__item--range');
    if(this.inputs.length == 0){
      this.inputs = this.querySelectorAll('.mobile-facets__range');
    }
    
    this.fixDisabledInputs();
    this.setMinAndMaxValues();
    this.checkFacets('constructor');
    this.fillColor();
    this.querySelectorAll('input[type="range"]')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    
    this.querySelectorAll('input[type="range"]')
      .forEach(element => element.addEventListener('input', this.fillColor.bind(this)));


  }

  checkFacets() {
    let name = (this.sliderName).replaceAll('.', '_');
    let facets = document.querySelectorAll(`a.${name}`);
    this.rangeFacet = document.querySelector(`.${name}--final`);
    this.rangeFacetMobile = document.querySelector(`.${name}--final-mobile`);
      
    this.rangeFacet && this.rangeFacet.addEventListener('click', this.eraseFilters)
    this.rangeFacetMobile && this.rangeFacetMobile.addEventListener('click', this.eraseFilters)
    let facetFirst = facets[0];
    let facetLast = facets[facets.length - 1];
    
    if(facetFirst){
      let spanFirst = facetFirst.querySelector('span span').textContent;
      if(Number(spanFirst) > Number(this.sliderOne.value) && Number(spanFirst) < Number(this.sliderTwo.value)){
        this.sliderOne.value = Number(spanFirst);
        this.displayValOne.textContent = this.formatValue(Number(spanFirst));
      }
    }
    if(facetLast){
      let spanLast = facetLast.querySelector('span span').textContent;
      if(Number(spanLast) < Number(this.sliderTwo.value) && Number(spanLast) > Number(this.sliderOne.value)){
        this.sliderTwo.value = Number(spanLast);
        this.displayValTwo.textContent = this.formatValue(Number(spanLast));
      }
    }
    for (const facet of facets) {
      facet.style.display = 'none';
    }
  }

  fixDisabledInputs(){
    let inputs = [];
    for (const input of this.inputs) {
      if(!input.disabled){
        inputs.push(input);
      }
    }
    this.inputs = inputs;
  }
  
  setMinAndMaxValues(){
    this.rangeOneInitialValue = Number(this.inputs[0].value);
    this.rangeTwoInitialValue = Number(this.inputs[this.inputs.length - 1].value);
    this.sliderName = this.inputs[0].name;
    this.sliderOne.setAttribute("min", Number(this.inputs[0].value));
    this.sliderTwo.setAttribute("min", Number(this.inputs[0].value));
    this.sliderOne.setAttribute("max", Number(this.inputs[this.inputs.length - 1].value));
    this.sliderTwo.setAttribute("max", Number(this.inputs[this.inputs.length - 1].value));
    this.sliderOne.setAttribute("value", Number(this.inputs[0].value));
    this.sliderTwo.setAttribute("value", Number(this.inputs[this.inputs.length - 1].value));
    this.displayValOne.textContent = this.formatValue(Number(this.inputs[0].value));
    this.displayValTwo.textContent = this.formatValue(Number(this.inputs[this.inputs.length - 1].value));
    this.sliderMaxValue = this.querySelector("#slider-1").max;
    this.sliderMinValue = this.querySelector("#slider-1").min;

    this.fillColor();
  }
  
  onRangeChange() {
    for (const input of this.inputs) {
      input.disabled = false;
      if(Number(input.value) >= Number(this.sliderOne.value) && Number(input.value) <= Number(this.sliderTwo.value)) {
        if(!input.checked){
          input.click();
        }
      }else{
        if(input.checked){
          input.click();
        }
      }
    }
    setTimeout(() => {
      let name = (this.sliderName).replaceAll('.', '_');
      this.rangeFacet = document.querySelector(`.${name}--final`);
      this.rangeFacetMobile = document.querySelector(`.${name}--final-mobile`);
    
      this.rangeFacet && this.rangeFacet.addEventListener('click', this.eraseFilters);
      this.rangeFacetMobile && this.rangeFacetMobile.addEventListener('click', this.eraseFilters);
    
    },1500)
  }

  fillColor(ev) {
    if(ev && ev.target.id == 'slider-1'){
      if (Number(this.sliderTwo.value) - Number(this.sliderOne.value) <= this.minGap) {
        this.sliderOne.setAttribute("value",Number(this.sliderTwo.value) - this.minGap);
        this.sliderOne.disabled = true;
        setTimeout(() => {
          this.sliderOne.disabled = false;
        },500)
      }else{
        this.sliderOne.setAttribute("value",Number(this.sliderOne.value));
      }

      this.displayValOne.textContent = this.formatValue(this.sliderOne.value);
    }
    if(ev && ev.target.id == 'slider-2'){
      if (Number(this.sliderTwo.value) - Number(this.sliderOne.value) <= this.minGap) {
        this.sliderTwo.setAttribute("value", Number(this.sliderOne.value) + this.minGap);
        this.sliderTwo.disabled = true;
        setTimeout(() => {
          this.sliderTwo.disabled = false;
        },500)
      }else{
        this.sliderTwo.setAttribute("value",Number(this.sliderTwo.value));
      }
      this.displayValTwo.textContent = this.formatValue(this.sliderTwo.value);
    }
    let percent1 = ((this.sliderOne.value - this.sliderMinValue) / ((this.sliderMaxValue - this.sliderMinValue) || 1)) * 100;
    let percent2 = (this.sliderTwo.value - this.sliderMinValue) / ((this.sliderMaxValue - this.sliderMinValue) || 1) * 100;
    this.sliderTrack.style.background = `linear-gradient(to right, #dadae5 ${percent1}% , #000 ${percent1}% , #000 ${percent2}%, #dadae5 ${percent2}%)`;
  }

  eraseFilters(ev){
    console.info(ev.target.parentNode.parentNode);
    let elementName = ev.target.parentNode.parentNode.getAttribute("name");
    let name = (elementName).replaceAll('.', '_');
    let facets = document.querySelectorAll(`a.${name}`);
    let url = window.location.href;
    for(let facet of facets){
      url = url.replace(`&${elementName}=${facet.querySelector('span span').textContent}`, '')
    }
    window.location.href = url;
  }

}
customElements.define('range-slider', RangeSlider);